module.exports = __webpack_public_path__ + "static/media/bg-4-art.a3c7e19d.png";